export default __webpack_public_path__ + "static/media/6.441933ff.webp";